import { unzip } from 'unzipit'

import { TileKey } from '@/utils/tileBounds'

// Matches the trailing {z}/{x}/{y}.png of a tile entry, tolerating a leading
// folder inside the archive (e.g. "tiles/12/345/678.png").
const TILE_ENTRY_REGEX = /(?:^|\/)(\d+)\/(\d+)\/(\d+)\.png$/i

export interface ExtractedTiles {
  // key `${z}/${x}/${y}` -> raw PNG bytes
  tiles: Map<string, Uint8Array>
  tileKeys: TileKey[]
}

// Unzips a chart-converter / processed tiles archive into an in-memory map keyed
// by `${z}/${x}/${y}`. Shared by the live converter (ChartConverterWebClient) and
// the server-tiles rehydration path (EnsureUserChartTilesUseCase). Non-tile
// entries are ignored.
export async function extractTilesFromZip(zipBuffer: ArrayBuffer): Promise<ExtractedTiles> {
  const { entries } = await unzip(zipBuffer)

  const tiles = new Map<string, Uint8Array>()
  const tileKeys: TileKey[] = []

  for (const [name, entry] of Object.entries(entries)) {
    const match = name.match(TILE_ENTRY_REGEX)
    if (!match) continue

    const z = Number(match[1])
    const x = Number(match[2])
    const y = Number(match[3])

    tiles.set(`${z}/${x}/${y}`, new Uint8Array(await entry.arrayBuffer()))
    tileKeys.push({ z, x, y })
  }

  return { tiles, tileKeys }
}
